module.exports = __webpack_public_path__ + "img/bg-intro-bonus.d44f938a.png";